(() => {
  const selectors = {
    drawerDiscount: '.drawer__discount',
    discountField: '.drawer__discountField',
    applyDiscountButton: '.drawer__discountButton',
    discountError: '.drawer__discountError',
    removeDiscountButton: '.appliedDiscount__removeButton',
    cartTotal: '#cartTotal',
    cartGift: '.cart__rowProductGift:not(.cart__rowProductGift--progress-bar)',
    openGiftsPopUp: '.giftPopUpButtonText',

    discountCookie: 'discount_code',
    removeGiftData: '[data-discount-gift]',

    applyDiscountButtonLoadingClass: 'btn--loading',
    removeDiscountButtonVisibleClass: 'appliedDiscount__removeButton--visible',
    activeClass: 'active',
  };

  const applyDiscountCodeQuery = `mutation applyDiscountCode($cartId: ID!, $discountCodes: [String!]) {
    cartDiscountCodesUpdate(
      cartId: $cartId
      discountCodes: $discountCodes
    ) {
      cart {
        discountCodes {
          applicable
          code
        }
      }
      userErrors {
        code
        message
      }
    }
  }`;

  theme.applyDiscountCode = async (e, code = null) => {
    if (e) {
      e.preventDefault();
    };

    const discountField = document.querySelector(selectors.discountField);
    const discountCode = code || discountField.value;
    const cartID = theme.getCookie('cart') ? `gid://shopify/Cart/${theme.getCookie('cart')}` : '';
    const discountObject = theme.getCookie('discount_object') ? JSON.parse(theme.getCookie('discount_object')) : '';
    const applyDiscountButton = document.querySelector(selectors.applyDiscountButton);
    const removeDiscountButton = document.querySelector(selectors.removeDiscountButton);
    let isError = false;

    try {
      const updateDiscountResponse = await theme.updateDiscountCode(cartID, discountCode);

      if (applyDiscountButton) {
        applyDiscountButton.classList.add(selectors.applyDiscountButtonLoadingClass);
        applyDiscountButton.disabled = true;
      }

      updateDiscountResponse.data.cartDiscountCodesUpdate.cart.discountCodes.forEach((code) => {
        if (!code.applicable) {
          isError = true;
        }
      });

      if (isError) {
        throw new Error('Error');
      }

      if (updateDiscountResponse.data) {
        if (theme.getCookie(selectors.discountCookie) !== discountCode || (discountObject && discountObject.code !== discountCode)) {
          theme.setCookie(selectors.discountCookie, discountCode);
        }

        localStorage.setItem(selectors.discountCookie, discountCode);
      }
    } catch (error) {
      const discountError = document.querySelector(selectors.discountError);

      if (discountField) {
        discountField.classList.add(selectors.discountFieldErrorClass);
        discountField.value = '';
      }

      discountError?.classList.add(selectors.activeClass);

      theme.deleteCookie(selectors.discountCookie);
      localStorage.removeItem(selectors.discountCookie);

      setTimeout(() => {
        discountError?.classList.remove(selectors.activeClass);
      }, 3000);
    } finally {
      if (!isError) {
        setTimeout(async () => {
          if (discountField && discountField.value === '') {
            discountField.value = discountCode;
          }

          removeDiscountButton?.classList.add(selectors.removeDiscountButtonVisibleClass);

          if (applyDiscountButton) {
            applyDiscountButton.innerText = applyDiscountButton.dataset.successText;
            applyDiscountButton.classList.remove(selectors.applyDiscountButtonLoadingClass);
          }

          await theme.checkDiscountGift(discountCode);
          await theme.checkCartState();
        }, 4000);
      } else {
        if (applyDiscountButton) {
          applyDiscountButton.disabled = false;
          applyDiscountButton.classList.remove(selectors.applyDiscountButtonLoadingClass);
        }
      };
    }
  };

  theme.updateDiscountCode = async (cartId, discountCodes) => {
    const applyDiscount = await fetch('https://happyglam-it.myshopify.com/api/2023-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'cfe8f429c05bd548c447ee7f2538ab0c',
      },
      body: JSON.stringify({
        query: applyDiscountCodeQuery,
        variables: {
          cartId,
          discountCodes,
        },
      }),
    });

    return applyDiscount.json();
  };

  theme.removeDiscountCode = async () => {
    const cartID = theme.getCookie('cart') ? `gid://shopify/Cart/${theme.getCookie('cart')}` : '';
    const discountsArray = [];
    const drawerDiscount = document.querySelector(selectors.drawerDiscount);
    const discountField = drawerDiscount.querySelector(selectors.discountField);
    const discountCode = theme.getCookie(selectors.discountCookie);
    const removeDiscountButton = drawerDiscount.querySelector(selectors.removeDiscountButton);
    const applyDiscountButton = drawerDiscount.querySelector(selectors.applyDiscountButton);
    const updateDiscountResponse = await theme.updateDiscountCode(cartID, discountsArray);
    const matchedCode = theme.free_gift.filter(function(e){ return e.discount_code.toUpperCase() === discountCode.toUpperCase() });
    const giftRemoveButton = document.querySelector(selectors.removeGiftData);
    let isError = false;

    applyDiscountButton?.classList.add(selectors.applyDiscountButtonLoadingClass);

    updateDiscountResponse.data.cartDiscountCodesUpdate.cart.discountCodes.forEach((code) => {
      if (!code.applicable) {
        isError = true;
      }
    });

    theme.deleteCookie(selectors.discountCookie);
    localStorage.removeItem(selectors.discountCookie);


    if (!isError) {
      if (matchedCode.length > 0) {
        ShopifyAPI.getCart(function(cart) {
          var updateData = { updates: {} };
          $.each(cart.items, function(index, product) {
            if (typeof product.properties !== 'undefined' && product.properties !== null) {
              if (typeof product.properties['gift'] !== 'undefined' && product.properties['gift'] !== null) {
                updateData.updates[product.id] = 0;
              }
            }
          });

          theme.updateProduct(updateData);
        });
      };

      if (giftRemoveButton && matchedCode.length == 0) {
        const item = { 'line': +giftRemoveButton.dataset.line, 'quantity': 0 };
        await theme.changeProduct(item);
      };

      setTimeout(async () => {
        await theme.checkCartState();

        if (discountField) {
          discountField.value = '';
        };

        removeDiscountButton?.classList.remove(selectors.removeDiscountButtonVisibleClass);

        if (applyDiscountButton) {
          applyDiscountButton.innerText = applyDiscountButton.dataset.defaultText;
          applyDiscountButton.classList.remove(selectors.applyDiscountButtonLoadingClass);
          applyDiscountButton.disabled = false;
        };
      }, 2000);
    }
  };

  theme.checkDiscountGift = async (discountCode) => {
    const matchedCode = theme.free_gift.filter(function(e){ return e.discount_code.toUpperCase().trim() === discountCode.toUpperCase().trim() });
    const freeGiftData = matchedCode.length > 0 ? matchedCode[0] : false;
    const cartPrice = document.querySelector(selectors.cartTotal);
    const price = parseFloat(cartPrice.innerText.substr(1).replace(",", "."));

    if (freeGiftData) {
      const discountMov = freeGiftData.discount_mov;
      const freeGiftCount = freeGiftData.free_gift_count;
      const selectedGifts = document.querySelectorAll(selectors.cartGift);

      ShopifyAPI.getCart(function(cart){
        let updateData = {updates:{}}, currentCount = 0;

        $.each(cart.items, function(index, product) {
          if (typeof product.properties !== 'undefined' && product.properties !== null) {
            if (typeof product.properties['gift'] !== 'undefined' && product.properties['gift'] !== null && product.properties['_block_id'] === 'undefined'){
              updateData.updates[product.id] = 0;
              currentCount ++;
            }
          }
        });
        if(price > discountMov) {
          if (currentCount == 0) {
            const textForButton = document.querySelector(selectors.openGiftsPopUp).innerText;
            const showPopUpButton = `<a href="#" class="openPopUpButton">${textForButton}</a>`;
            const discountAmount = discountMov * 100;

            if(!document.querySelector('.openPopUpButton') && freeGiftCount != '') {
              theme.setCookie('giftCount', freeGiftCount);
              theme.setCookie('giftCollection', freeGiftData.collection);
              document.querySelector('.cart__products form').insertAdjacentHTML('beforeend', showPopUpButton);
              document.querySelector('.openPopUpButton').addEventListener("click", function(event) {
                event.preventDefault();
                theme.openGiftsPopUp(freeGiftCount, currentCount, freeGiftData.collection, discountAmount);
              })
            }

            if (freeGiftCount != '' && +selectedGifts.length !== +freeGiftCount) {
              document.querySelector('.openPopUpButton').click();
            }
          }
        } else {
          if(currentCount > 0) {
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: updateData,
              dataType: 'json',
              success: function(cart){
                location.reload();
              }
            });
          }
        }
      });
    }

    if(theme.gift_discounts_list.length > 0) {
      let discount_match_array = [];

      theme.gift_discounts_list.forEach(object => {
        if(object.code.toUpperCase().trim() === discountCode.toUpperCase().trim()) {
          discount_match_array.push(object.relatedTo);
        }
      });

      if(discount_match_array.length > 0) {
        let items = [];

        discount_match_array.forEach(item => {
          if(document.querySelector(`.${item}`)) {
            let gift_json = document.querySelector(`.${item}`);

            items.push(JSON.parse(gift_json.text));
          }
        })

        await theme.addProduct(items);
      }
    };
  };

  theme.initDiscountListeners = () => {
    const removeDiscountButton = document.querySelector(selectors.removeDiscountButton);

    removeDiscountButton?.addEventListener('click', theme.removeDiscountCode);
  };

  theme.initDiscountListeners();
})();
